<ul id="backendErrorList" class="grid-list errors-block" *ngIf="listError.length > 0">
  <li *ngFor="let error of listError" class="invalid-fields">{{ error }}</li>
</ul>
